import { Box, Text } from '@mantine/core';
import { ReactNode } from 'react';

import { useEucdmCodes } from '@hooks/useEucdmCodes';

interface EucdmCodeProps {
  path: string;
  children: ReactNode;
}

export const EucdmCode: React.FC<EucdmCodeProps> = ({ path, children }) => {
  const { getCode } = useEucdmCodes();
  const code = getCode(path);

  return (
    <Box>
      {children}
      {code && (
        <Text size="sm" c="dimmed" mt={4}>
          {code}
        </Text>
      )}
    </Box>
  );
};
